const PlanType = {
  WVS: 'VDSL',
  EUBA: 'ADSL',
  UFB: 'Fibre'
};

export default PlanType;



/** WEBPACK FOOTER **
 ** ./src/common/PlanType.js
 **/